import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=a4860842&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=js&"
export * from "./ServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=a4860842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4860842",
  null
  
)

export default component.exports